import clsx from "clsx";
import React, { Dispatch, SetStateAction, useCallback } from "react";
import { useNavigationContext } from "web/react/components/navigation/navigation.context";
import { Text } from "web/react/emo/text";
import { MenuLinkSerializer, SubMenuSerializer } from "web/types/serializers";
import * as styles from "./sticky-categories.css";

export interface StickyCategoriesProps {
    menus: SubMenuSerializer[];
    links: MenuLinkSerializer[];
    selectedCategory: SubMenuSerializer | null;
    setSelectedCategory: Dispatch<SetStateAction<SubMenuSerializer | null>>;
}

export function StickyCategories({
    menus,
    links,
    selectedCategory,
    setSelectedCategory,
}: StickyCategoriesProps): React.ReactElement {
    const { setShowMenu, handleCategoryAnalytics } = useNavigationContext();

    const onHover = useCallback(
        function (menu: SubMenuSerializer): void {
            setSelectedCategory(menu);
            setShowMenu("desktop");
            handleCategoryAnalytics("product_type", "impression");
        },
        [handleCategoryAnalytics, setSelectedCategory, setShowMenu]
    );

    const onHoverLink = useCallback(
        function (): void {
            setSelectedCategory(null);
            setShowMenu(null);
        },
        [setSelectedCategory, setShowMenu]
    );

    return (
        <nav>
            <div className={styles.container}>
                {menus.map((menu, i) => {
                    return (
                        <div
                            className={clsx(styles.stickyItem, {
                                [styles.active]:
                                    selectedCategory?.display_name === menu.display_name,
                            })}
                            key={`${i}-${menu.display_name}`}
                            onMouseEnter={() => onHover(menu)}
                        >
                            <Text textStyle="body-3">{menu.display_name}</Text>
                        </div>
                    );
                })}
                {links.map((link, i) => {
                    const isSaleLink = link.is_sale;
                    return (
                        <a
                            className={styles.stickyItem}
                            key={`${i}-${link.text}`}
                            href={link.url}
                            onMouseEnter={onHoverLink}
                        >
                            <Text textStyle="body-3" color={isSaleLink ? "error" : "primary"}>
                                {link.text}
                            </Text>
                        </a>
                    );
                })}
            </div>
        </nav>
    );
}
